<template>
  <v-app>
    <v-navigation-drawer v-model="controls.drawer" app class="grey lighten-4">
      <v-layout
        align-center
        justify-center
        column
        class="pt-6 pb-4 grey lighten-5"
      >
        <div class="app-logo-sheet">
          <v-img
            :src="require('@/assets/images/logo.png')"
            width="68px"
            height="64px"
            class="ma-6"
          >
          </v-img>
        </div>
        <div class="headline mt-4">Mustard Leadership</div>
        <div class="caption">Admin CMS</div>
      </v-layout>
      <v-list flat>
        <v-subheader>
          <div class="font-weight-bold grey--text mx-auto">NAVIGATION</div>
        </v-subheader>
        <template v-for="item in navItems">
          <v-list-item
            v-if="!item.children"
            link
            :key="item.label"
            :to="item.to"
            class="font-weight-bold"
          >
            <v-list-item-content>
              <v-list-item-title
                class="pa-2 app-nav--item"
                @click="markReadAlerts(item.to.name)"
                >{{ item.label }}</v-list-item-title
              >
            </v-list-item-content>

            <v-list-item-icon
              class="app-nav--icon primary lighten-1"
              v-if="item.notification"
            >
              <v-icon dense size="12">
                {{ item.notification }}
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-group v-else :key="item.label">
            <template v-slot:activator>
              <v-list-item-title class="pa-2 app-nav--item font-weight-bold">
                {{ item.label }}
              </v-list-item-title>
            </template>
            <v-list-item
              class="pl-8"
              v-for="child in item.children"
              :key="child.label"
              link
              :to="child.to"
            >
              <v-list-item-title
                class="pa-2 app-nav--item"
                @click="markReadAlerts(child.to.name)"
              >
                {{ child.label }}
              </v-list-item-title>
              <v-list-item-icon
                class="app-nav--icon primary lighten-1"
                v-if="child.notification"
              >
                <v-icon dense size="12">
                  {{ child.notification }}
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-slot:append>
        <v-list class="grey lighten-5 pa-0">
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-list-item two-line v-on="on">
                <v-list-item-avatar>
                  <v-avatar class="ma-2" color="grey lighten-2">
                    <img :src="avatarThumb" alt="avatar" />
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title> {{ user.full_name }} </v-list-item-title>
                  <v-list-item-subtitle> Position </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item
                :to="{ name: 'admin.details', params: { id: user.id } }"
              >
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-title>Log out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-content>
      <v-container class="px-6">
        <slot />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import { mapState, mapActions, mapGetters } from 'vuex'
import forEach from 'lodash/forEach'

export default {
  name: 'MainLayout',

  mixins: [ControlsMixin],

  data() {
    return {
      navItems: [
        { label: 'Users', to: { name: 'users' } },
        {
          label: 'Sign-ups',
          to: { name: 'inquiries' },
          notification: 0
        },
        { label: 'Groups', to: { name: 'groups' } },
        { label: 'News', to: { name: 'news' } },
        { label: 'Resources', to: { name: 'resources' } },
        { label: 'Notifications', to: { name: 'notifications' } },
        {
          label: 'Training',
          children: [
            { label: 'Resources', to: { name: 'training.resources' } },
            { label: 'Blogs', to: { name: 'training.blogs' } }
          ]
        },
        {
          label: 'Calendar',
          children: [
            { label: 'Master', to: { name: 'calendar.master' } },
            { label: 'Mustard', to: { name: 'calendar.mustard' } }
          ]
        },
        { label: 'Suggestions', to: { name: 'suggestions' }, notification: 0 },
        {
          label: 'Posts Reports',
          to: { name: 'report.posts' },
          notification: 0
        },
        {
          label: 'Comments Reports',
          to: { name: 'report.comments' },
          notification: 0
        }
      ]
    }
  },

  mounted() {
    this.setAlert()
  },

  watch: {
    $route() {
      this.setAlert()
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      alerts: state => state.alerts
    }),
    ...mapGetters({
      avatarThumb: 'auth/avatarThumb'
    })
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      getUnreadAlerts: 'alerts/getUnreadAlerts',
      markReadAlerts: 'alerts/markReadAlerts'
    }),

    async setAlert() {
      await forEach(this.navItems, async item => {
        let nav = item.to ? item.to.name : ``
        let subnav = item.children
        let subLabel = item.label.toLowerCase()

        if (nav && this.alerts[nav]) {
          nav = nav.includes('.') ? nav.replace('.', '_') : nav
          await this.getUnreadAlerts(nav.toUpperCase()).then(resp => {
            item.notification = resp
          })
        } else if (subnav && this.alerts[subLabel]) {
          await forEach(subnav, async sub => {
            let subName = sub.to.name.replace('.', '_').toUpperCase()
            await this.getUnreadAlerts(subName).then(resp => {
              sub.notification = resp
            })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style>
.app-logo-sheet {
  border-radius: 28px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
.v-navigation-drawer__border {
  background-color: transparent !important;
}
.app-nav--icon {
  height: 25px;
  width: 20px;
  border-radius: 20px;
  text-align: center;
}
.app-nav--icon i {
  color: white !important;
  font-style: normal;
  font-weight: bold;
  margin: auto;
  letter-spacing: 0em !important;
  line-height: 2em !important;
}
</style>
